import React, { Component } from 'react'

import FontIcon from '../../atoms/FontIcon'
import style from './style.css'
export default class ActionBtnIcon extends Component {
    render() {
        return (
            <div
                className={`${style.btn} ${style[this.props.theme]}`}
                style={{
                    width: `${this.props.size || 30}px`,
                    height: `${this.props.size || 30}px`,
                    cursor: `${this.props.action ? 'pointer' : ''}`,
                    ...this.props.style
                }}
                onClick={(e) => { if(this.props.action) this.props.action(e) }}>
                <FontIcon size={(this.props.size || 30) * 0.4} name={this.props.icon} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/ActionBtnIcon/index.js